__turbopack_context__.v({
  "stadiumFansActions": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansActions",
  "stadiumFansBand": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansBand",
  "stadiumFansBandInner": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansBandInner",
  "stadiumFansBody": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansBody",
  "stadiumFansBodyDesktop": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansBodyDesktop",
  "stadiumFansBodyLine": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansBodyLine",
  "stadiumFansBodyLineMobileSingle": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansBodyLineMobileSingle",
  "stadiumFansBottomBlend": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansBottomBlend",
  "stadiumFansCopy": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansCopy",
  "stadiumFansDarken": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansDarken",
  "stadiumFansForeground": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansForeground",
  "stadiumFansGrain": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansGrain",
  "stadiumFansImage": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansImage",
  "stadiumFansPrimaryBtn": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansPrimaryBtn",
  "stadiumFansPrimaryBtnIcon": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansPrimaryBtnIcon",
  "stadiumFansPrimaryBtnText": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansPrimaryBtnText",
  "stadiumFansSecondaryBtn": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansSecondaryBtn",
  "stadiumFansTitle": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansTitle",
  "stadiumFansTopBlend": "FansStadiumCta-module-scss-module__9HZtGW__stadiumFansTopBlend",
});
